import { Skeleton } from "@nextui-org/react";

export function SessionTableSkeleton() {
  return (
    <div className="flex-1 overflow-auto bg-white">
      {/* Table Header Skeleton */}
      <div className="flex items-center px-6 py-3 border-b border-[#E4E4E7] bg-[#F9FAFB]">
        <Skeleton className="h-4 w-24 rounded" />
        <div className="flex-1" />
        <Skeleton className="h-4 w-20 rounded mx-4" />
        <Skeleton className="h-4 w-16 rounded mx-4" />
        <Skeleton className="h-4 w-24 rounded mx-4" />
        <Skeleton className="h-4 w-20 rounded mx-4" />
        <Skeleton className="h-4 w-5 rounded" />
      </div>

      {/* Data Row Skeletons */}
      {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((i) => (
        <div key={i} className="flex items-center px-6 py-4 bg-white border-b border-[#E4E4E7]">
          <Skeleton className="h-4 w-40 rounded" />
          <div className="flex-1" />
          <Skeleton className="h-4 w-28 rounded mx-4" />
          <div className="flex items-center gap-2 mx-4">
            <Skeleton className="h-6 w-6 rounded-full" />
            <Skeleton className="h-4 w-24 rounded" />
          </div>
          <Skeleton className="h-4 w-20 rounded mx-4" />
          <div className="flex items-center gap-2 mx-4">
            <Skeleton className="h-6 w-6 rounded-full" />
            <Skeleton className="h-4 w-24 rounded" />
          </div>
          <Skeleton className="h-5 w-5 rounded" />
        </div>
      ))}
    </div>
  );
}
